import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step1Img from './Step 1 Image.png';
import step2Img from './Step 2 Image.png';
import step4Img from './Step 4 Image.png';

// Header
const headerText = `Entering Mailing Information`;
const subtitleText = `This is where your house share related mail will go unless you designate an application with a
                        primary residency, in which case all house share related mail will go to that address.`;

// Steps
const step1Text = `Click “Enter Mailing Address” on your Account Dashboard.`;
const step2Text = `Complete all required contact information. Please note that while a phone number is not
                    required, providing one will allow BACP to contact you more quickly if needed. Otherwise, they
                    will use one of the other options, potentially delaying the time in which you are notified should
                    the need arise.`;
const step3Text = `Be sure to click “Save” once you have entered all of your information.`;
const step4Text = `To verify that this step is complete, go back to your Account Dashboard. The “Enter mailing
                    address” box will no longer be present, confirming that this step requires no further action.`;

const EnteringMailingInformation = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <HowToStep stepNumber={1} content={step1Text} imgSrc={step1Img} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} />
      <HowToStep stepNumber={4} content={step4Text} imgSrc={step4Img} />
    </>
  );
};

export default EnteringMailingInformation;
